import { Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";

const img1 =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/Recuperacion_del_centro-medico_MEDAM.png";

const img2 =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png";

const img3 =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png";

const img4 =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/Recuperacion_urgencias_del_centro-medico_MEDAM.png";

const PhotosHospitalization = () => {
  const { isMobile, isDesktop } = useContext(ScreenContext);

  return (
    <Grid container width="100%">
      <Grid size={design.Grid1} />
      <Grid container size={design.Grid10}>
        <Grid size={design.Grid6} sx={design.alignContent}>
          <ImageLoader
            src={img1}
            alt={img1}
            width="97%"
            height={isMobile ? 200 : 300}
            borderRadius={3}
          />
          <ImageLoader
            src={img2}
            alt={img2}
            width="97%"
            height={isMobile ? 200 : 650}
            borderRadius={3}
          />
        </Grid>
        <Grid size={design.Grid6} pt={isMobile && 2} sx={design.alignContent}>
          <ImageLoader
            src={img3}
            alt={img3}
            width="97%"
            height={isMobile ? 200 : 650}
            borderRadius={3}
          />
          <ImageLoader
            src={img4}
            alt={img4}
            width="97%"
            height={isMobile ? 200 : 300}
            borderRadius={3}
          />
        </Grid>
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};
export default PhotosHospitalization;
const design = {
  alignContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    gap: 3,
  },
  Grid1: { xs: 12, md: 1, xl: 1, lg: 1 },
  Grid6: { xs: 12, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 12, md: 10, xl: 10, lg: 10 },
};
